import { DestroyRef, inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { type RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import type { Subscription } from 'rxjs';
import { APP_TITLE, APP_TITLE_SEPARATOR } from '@core/constants/app-title.constants';

/**
 * The tab reads "<page> · Brooch CRM". A route's `title` is a translation key (the page header's own),
 * shown in the current language and again when the language changes; a route without one shows
 * "Brooch CRM".
 */
@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);
  private current: Subscription | null = null;

  constructor() {
    super();
    inject(DestroyRef).onDestroy(() => this.current?.unsubscribe());
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const key = this.buildTitle(snapshot);
    this.current?.unsubscribe();
    this.current = null;
    if (!key) {
      this.title.setTitle(APP_TITLE);
      return;
    }
    this.current = this.translate
      .stream(key)
      .subscribe((page: string) =>
        this.title.setTitle(`${page}${APP_TITLE_SEPARATOR}${APP_TITLE}`)
      );
  }
}
